import { render, staticRenderFns } from "./suporte-grupo-repasses.vue?vue&type=template&id=165fb0ab"
import script from "./suporte-grupo-repasses.vue?vue&type=script&lang=ts"
export * from "./suporte-grupo-repasses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports